import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import MenuCard01 from 'components/Software/macOS/InstarVision/Record/instarVisionMenuCards01';
import MenuCard02 from 'components/Software/macOS/InstarVision/Record/instarVisionMenuCards02';
import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  MenuCard01,
  MenuCard02,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};